<template>
	<div class="container">
		<div class="page">
			<!-- Header -->
			<div class="page-header">
				<div class="row">
					<div class="col-md-9">
						<h1 class="page-title">{{ $t('Warehouses') }}</h1>
					</div>
				</div>
			</div>

			<!-- Table Menu -->
			<div class="table-list-menu d-lg-flex align-items-center">
				<div class="table-actions d-flex align-items-center flex-wrap">
					<!-- Add Warehouse -->
					<a v-if="warehouseNotNull" @click="openFormWarehouse('add')"
						class="btn btn-primary btn-sm flex-center mr-2">
						<i class="material-icons">add</i>
						<span>{{ $t('Tambah Warehouse') }}</span>
					</a>
				</div>
			</div>

			<div class="products-list">
				<div class="row">
					<div class="col-12 col-md-6" v-for="warehouse in allWarehouse" :key="warehouse._id.$oid">
						<div class="box box-padding">
							<div class="row mx-0">
								<div class="col-sm-8">
									<div class="d-flex justify-content-between align-items-center">
										<div class="d-flex p-1 bg-gray rounded h-auto w-auto">
											<i class="warehouse__icon material-icons">warehouse</i>
										</div>

										<div class="ml-3">
											<span class="integration__title">
												{{ warehouse.label }}
											</span>
											<div class="integration__info"></div>
											<small class="text-left text-small" v-if="warehouse.address.length < 25">
												{{ warehouse.address }},
												{{ setAddress(warehouse) }}
											</small>
											<small v-else v-tooltip="`${warehouse.address}, ${setAddress(warehouse)}`
												" class="mt-1 text-left text-small">
												{{
													warehouse.address.length > 25
													? warehouse.address.substr(0, 25) + "... "
													: warehouse.address
												}},
												<span>
													{{ setAddress(warehouse) }}
												</span>
											</small>
										</div>
									</div>
								</div>

								<div class=" col-sm-4">
									<div class="d-flex justify-content-end">
										<button v-tooltip="$t('Edit Warehouse')"
											v-if="!warehouse.is_deleted"
											@click="openFormWarehouse('edit', warehouse)"
											class="btn bg-gray btn-light btn-sm mr-2">
											<i class="material-icons btn-icon">edit</i>
										</button>
										<button v-tooltip="$t('Restore Warehouse')"
											v-if="warehouse.is_deleted"
											@click="openModalDeleteWarehouse(warehouse, 'restore')"
											class="btn bg-danger btn-light btn-sm">
											<i class="material-icons btn-icon text-white">delete</i>
										</button>
										<button v-tooltip="$t('Delete Warehouse')"
											v-else
											@click="openModalDeleteWarehouse(warehouse, 'delete')"
											class="btn bg-gray btn-light btn-sm">
											<i class="material-icons btn-icon">delete</i>
										</button>
									</div>
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>

			<div v-if="!warehouseNotNull && isFetching === false" class="list-empty b-0">
				<div>
					<i class="material-icons md-48 mr-2">error_outline</i><span>Tidak Ada Data Warehouse.</span>
				</div>
				<div class="mt-2">
					<button @click="openFormWarehouse('add')" type="button" class="integration-app-button btn btn-primary">
						+ <span class="ml-2">{{ $t("Add Warehouse") }}</span>
					</button>
				</div>
			</div>

			<!-- Table Loader -->
			<div class="table-fetch-status" v-if="isFetching">
				<div class="is-loading large dark m-auto"></div>
			</div>

			<!-- Modals -->
			<div class="modals">

				<warehouse-form :show="isShowFormWarehouse" :formType="warehouseFormType"
					:selectedWarehouse="selectedWarehouse" @close="isShowFormWarehouse = false" @set="submit" />

				<warehouse-delete v-if="isShowDeleteWarehouse" :warehouse="selectedWarehouse"
					@close="isShowDeleteWarehouse = false" :type="deleteType" @set="deleteDataWarehouse" />

			</div>

		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import warehouseApi from '@/api/warehouse';
import { getAxiosErrorMessage } from '@/lib/helper';
import WarehouseForm from '@/components/WarehouseForm.vue';
import WarehouseDelete from '@/components/DeleteWarehouse.vue';

export default {
	name: 'warehouse',
	components: {
		WarehouseForm,
		WarehouseDelete,
	},
	data() {
		return {
			selectedWarehouse: {},
			warehouseFormType: '',
			allWarehouse: [],
			isShowFormWarehouse: false,
			isShowDeleteWarehouse: false,
			isFetching: false,
			deleteType: 'delete',
		};
	},
	methods: {
		getListAllWarehouse() {
			this.isFetching = true;
			const params = {
				page: 1,
				limit: 100,
			};
			if (this.user.role === 'admin' || this.user.role === 'superadmin') {
				params.created_by_admin = true;
			}
			const callback = (response) => {
				const warehouses = response.data;
				// console.log(warehouses);
				this.allWarehouse = warehouses;
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Warehouses',
					text: message,
				});
				this.isFetching = false;
			};
			warehouseApi.getWarehouses(params, callback, errorCallback);
		},

		setAddress(warehouse) {
			const address = `${warehouse.subdistrict.name} ${warehouse.city.name} ${warehouse.province.name}`;
			return address;
		},

		updateWarehouse(updatedWarehouse) {
			const index = this.allWarehouse.findIndex(curr => curr._id === updatedWarehouse._id);
			if (index !== -1) {
				this.allWarehouse[index] = updatedWarehouse;
			}
		},

		storeNewWarehouse(newWarehouse) {
			const warehouses = this.allWarehouse;
			warehouses.unshift(newWarehouse);
			this.allWarehouse = warehouses;
		},

		openFormWarehouse(type, warehouse = null) {
			this.warehouseFormType = type;
			this.isShowFormWarehouse = true;

			if (warehouse !== null) {
				this.selectedWarehouse = warehouse;
			}
		},

		submit(warehouse) {
			if (this.warehouseFormType === 'edit') {
				this.updateWarehouse(warehouse);
				this.showNotify(
					this.$t('Update Warehouse'),
					this.$t('Warehouse Update Successfully'),
					'success',
				);
			} else {
				this.storeNewWarehouse(warehouse);
				this.showNotify(
					this.$t('Add Warehouse'),
					this.$t('Warehouse Added Successfully'),
					'success',
				);
			}
		},

		showNotify(title, text, type) {
			this.$notify({
				group: 'app',
				title,
				text,
				type,
			});
		},

		openModalDeleteWarehouse(warehouse = null, deleteType = 'delete') {
			this.deleteType = deleteType;
			this.selectedWarehouse = warehouse;
			this.isShowDeleteWarehouse = true;
		},

		deleteDataWarehouse(deletedWarehouse) {
			this.deleteWarehouse(deletedWarehouse);
			this.isShowDeleteWarehouse = false;
		},

		deleteWarehouse(deletedWarehouse) {
			const index = this.allWarehouse.findIndex(warehouse => warehouse._id === deletedWarehouse._id);
			const warehouses = this.allWarehouse;
			if (index !== -1) {
				const warehouse = warehouses[index];
				if (this.deleteType === 'restore') {
					warehouse.is_deleted = false;
				} else {
					warehouse.is_deleted = true;
				}
			}
			this.allWarehouse = warehouses;
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		warehouseNotNull() {
			return this.allWarehouse.length > 0;
		},
	},
	watch: {
		user() {
			this.getListAllWarehouse();
		},
	},
	mounted() {
		if (this.user) {
			this.getListAllWarehouse();
		}
	},
};
</script>

<style scoped>
.warehouse__icon {
	font-size: 30px;
}

.bg-gray {
	background-color: #e1eaef;
}

.box-padding {
	/* padding: 25px; */
	min-height: 120px;
}

.btn-rounded {
	border-radius: 100%;
	background: #e1eaef;
	margin: 0 0 0 10px;
	/* padding: 10px; */
}

.btn-icon {
	color: #21252999;
	font-size: 13px;
}
</style>
